import React, { Component } from 'react';
import 'styled-components/macro';
import { css, withTheme, Theme } from 'styled-components';
import { Context } from '../../i18n';

class SubmitButton extends Component<{
  onSubmit: (event: React.MouseEvent<HTMLElement>) => void;
  confirmBtnAble: boolean;
  theme: Theme;
}> {
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  render() {
    const { confirm } = this.context;
    const { confirmBtnAble } = this.props;
    const {
      sureBtnBgColor,
      sureBtnFontColor,
      sureBtnBorderRadius,
      sureBtnBgOpacity,
    } = this.props.theme;
    return (
      <div
        className="verify-captcha-submit-button"
        onClick={this.props.onSubmit}
        css={css`
          height: 32px;
          line-height: 32px;
          width: 65px;
          background-color: ${sureBtnBgColor};
          color: ${sureBtnFontColor};
          text-align: center;
          font-size: 14px !important;
          border-radius: ${sureBtnBorderRadius};
          float: right;
          opacity: ${confirmBtnAble ? 1 : sureBtnBgOpacity};
          filter: alpha(opacity= ${confirmBtnAble ? 100 : 50});
          cursor: ${confirmBtnAble ? 'pointer' : 'not-allowed'};
        `}
      >
        {confirm}
      </div>
    );
  }
}
export default withTheme(SubmitButton);
